$(document).on('click', ".ajax-link, .ajax-btn", function () {
    $(this).attr("disabled", true).html("<i class='fa fa-spinner fa-spin'></i>")
});

$(document).ajaxComplete(function() {
    $("#page-overlay").fadeOut(300);
});

